import OBTOGridExtended from './OBTOGridExtended';
import 'jqGrid/css/addons/ui.multiselect.css';
import 'jqGrid/js/addons/ui.multiselect';
import 'jqGrid/js/i18n/grid.locale-en';
import 'jqGrid/js/jquery.jqGrid.min';
import 'jqGrid/css/ui.jqgrid-bootstrap4.css';
import './obto-data-service';

import swal from 'sweetalert2';
import moment from 'moment-timezone';
import async from 'async';
import * as _ from 'underscore';
import * as NProgress from 'nprogress';
import feather from 'feather-icons';
import 'jquery-contextmenu';

import CopyClipBoard from './CopyClipBoard';
import { format } from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginEstree from "prettier/plugins/estree";


export default angular.module('jqgrid', ['obto.data.service'])
    .directive('jqGrid', ['$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$ngRedux',
        function ($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $ngRedux) {
            let jqGridCounter = 0;
            let isMobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
            return {
                replace: true,
                restrict: 'E',
                scope: {
                    domain: '@',
                    table: '=',
                    columnModel: '=',
                    columnOptions: '@',
                    container: '@',
                    filter: "=",
                    fvalue: "@",
                    search: '@',
                    config: '=',
                    type: '@',
                    parentdiv: '@',
                    open: '=',
                    filterData: '=',
                    requestQueryParams: '=',
                    gridOptions: '='
                },
                template: '<div id="outer" style="position: relative"><table id="table"/><div class="jqgrid-pagination"></div></div>',
                controllerAs: 'gridcontroller',
                controller: ['$scope', '$element', function ($scope, $element) {
                    $scope.editRow = function (row) {
                        $element.find('table').editRow(row);
                    };
                    $scope.saveRow = function (row) {
                        $element.find('table').saveRow(row);
                    };
                    $scope.restoreRow = function (row) {
                        $element.find('table').restoreRow(row);
                    };
                    $scope.filterData = $scope.filterData || {};

                    $scope.months = {
                        "0": "Jan",
                        "1": "Feb",
                        "2": "Mar",
                        "3": "Apr",
                        "4": "May",
                        "5": "Jun",
                        "6": "Jul",
                        "7": "Aug",
                        "8": "Sept",
                        "9": "Oct",
                        "10": "Nov",
                        "11": "Dec"
                    };
                    $scope.obtoSearchMap = {
                        'eq': '',
                        'ne': '!',
                        'lt': '<',
                        'le': '<=',
                        'gt': '>',
                        'ge': '>=',
                        'bw': '=',
                        'bn': '!=',
                        'in': 'IN',
                        'ni': 'NIN',
                        'ew': '',
                        'en': '',
                        'cn': '*',
                        'nc': '!*',
                        'nu': 'EMPTY',
                        'nn': 'NOTEMPTY'
                    };
                }],
                link: function (scope, element, attrs) {
                    scope.filterData = scope.filterData || {};
                    scope.project = "";
                    scope.dataUrl = "/o/recs/" + scope.table;
                    scope.gridData = {};
                    scope.container = "#jqgridContainer-" + scope.container;
                    scope.onChangeFunction = [];
                    scope.onLoadFunction = [];

                    let gridOptions = scope.gridOptions;
                    if (typeof scope.gridOptions === 'string') {
                        try {
                            gridOptions = JSON.parse(scope.gridOptions);
                        } catch (e) {
                            gridOptions = {
                                embedded: false
                            };
                        }

                    }

                    const gridHeight = gridOptions.gridHeight || '42vh';
                    const searchEnabled = typeof gridOptions.searchEnabled === "undefined" ? true : gridOptions.searchEnabled;
                    const embedded = gridOptions.embedded || false;

                    console.log('embedded', embedded);

                    let templateName = scope.table;
                    let targetPages = ['ob-connect', 'sofos-notice-board', 'imitate', 'ob-domains', 'switchdomain'];

                    const dataStore = {};
                    let filter = "",
                        storeId = {},
                        storeId2 = {},
                        storeId3 = {},
                        storeId4 = {},
                        shouldIShrink = false,
                        defaultPageSize = 25,
                        filters = [],
                        gridWidth = 0,
                        sortOrder = 'desc',
                        sortName = 'updated_on',
                        cellEditing = true,
                        isNavGridEnabled = true,
                        inlineNav = true,
                        navAdd = true,
                        navEdit = true,
                        navDelete = true,
                        references = [],
                        mreferences = [],
                        dates = [],
                        numbers = [],
                        dt = [],
                        obto = {},
                        settings = {
                            dateFormat: $rootScope.globalAttributes['co.obto.domain.date.format'] || "DD-MM-YYYY",
                            dateTimeFormat: $rootScope.globalAttributes['co.obto.domain.datetime.format'] || "DD-MM-YYYY hh:mm:ss a",
                            timezone: $rootScope.timezone || moment.tz.guess()

                        },
                        oldValue = "",
                        lastSel = -1,
                        lastSelCellName, _ids = [],
                        selICol, selIRow //iRow of selected cell
                        , readyForNext = false,
                        currentRow = 1,
                        token = $rootScope._csrf,
                        gridNumber = jqGridCounter++,
                        wrapperId = 'table-' + scope.parentdiv,//gridNumber,
                        tableId = 'jqgrid-table-' + gridNumber,
                        table = element.find('table'),
                        grid = table;

                    function offset(el) {
                        var rect = el.getBoundingClientRect(),
                            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        return {
                            top: rect.top + scrollTop,
                            left: rect.left + scrollLeft
                        };
                    }


                    setTimeout(() => {

                        if (templateName && targetPages.indexOf(templateName) === -1) {
                            let title = templateName.replace(/[_-]/g, " ");
                            title = title.replace("pltf", "").trim();
                            title = title.replace(".html", "").trim();
                            title = title.replace("v2", "").trim();
                            title = title.charAt(0).toUpperCase() + title.slice(1);
                            $rootScope.$broadcast('event:titlechanged', title);
                        }
                    }, 600);

                    if (!_.isUndefined(scope.columnModel) && scope.columnModel.length !== 0)
                        scope.project = scope.columnModel.join().toLowerCase();
                    else
                        scope.columnModel = [];

                    if (_.isUndefined(scope.columnOptions)) {
                        scope.columnOptions = {};
                    }

                    const caculateWidth = (loc, shouldIShrink) => {
                        console.log(loc + "::" + $('#table-' + scope.parentdiv).width(), shouldIShrink);
                        // Get width of parent container
                        let width = $('#table-' + scope.parentdiv).width(); //.attr('clientWidth');
                        if (width === null || width < 1) {
                            // For IE, revert to offsetWidth if necessary
                            width = jQuery('#' + scope.parentdiv).attr('offsetWidth');
                        }
                        if (gridWidth > 0 && gridWidth > width) {
                            width = gridWidth;
                        }
                        if (width > 0 &&
                            // Only resize if new width exceeds a minimal threshold
                            // Fixes IE issue with in-place resizing when mousing-over frame bars
                            Math.abs(width - table.width()) > 5) {
                            width = width - 2; // Fudge factor to prevent horizontal scrollbars
                            // console.log(typeof gridWidth, width.toString(), gridWidth );
                            // $compile(element.contents())(scope);
                            table.jqGrid('setGridWidth', width.toString());
                        }

                        element.find('.ui-jqgrid-bdiv').css('height', gridHeight);
                        // element.find(".glyphicon-refresh").attr('data-feather', 'refresh-cw');
                        // element.find(".glyphicon-plus").attr('data-feather', 'plus');
                        // element.find(".glyphicon-step-backward").attr('data-feather', 'skip-back');
                        // element.find(".glyphicon-backward").attr('data-feather', 'rewind');
                        // element.find(".glyphicon-forward").attr('data-feather', 'fast-forward');
                        // element.find(".glyphicon-step-forward").attr('data-feather', 'skip-forward');
                        // element.find(".glyphicon-menu-hamburger").attr('data-feather', 'menu');
                        // element.find(".glyphicon-save").attr('data-feather', 'save');
                        // element.find(".glyphicon-remove-circle").attr('data-feather', 'x-circle');
                        // element.find(".glyphicon-trash").attr('data-feather', 'trash-2');

                        element.find(".fa-refresh").attr('data-feather', 'refresh-cw');
                        element.find(".fa-sync").attr('data-feather', 'refresh-cw');
                        element.find(".fa-plus").attr('data-feather', 'plus');
                        element.find(".fa-step-backward").attr('data-feather', 'skip-back');
                        element.find(".fa-backward").attr('data-feather', 'rewind');
                        element.find(".fa-forward").attr('data-feather', 'fast-forward');
                        element.find(".fa-step-forward").attr('data-feather', 'skip-forward');
                        element.find(".fa-menu-hamburger").attr('data-feather', 'menu');
                        element.find(".fa-ellipsis-v").attr('data-feather', 'more-vertical');
                        element.find(".fa-save").attr('data-feather', 'save');
                        element.find(".fa-columns").attr('data-feather', 'more-vertical');
                        element.find(".fs-remove-circle").attr('data-feather', 'x-circle');
                        element.find(".fa-copy").attr('data-feather', 'copy');
                        element.find(".fa-file-excel").attr('data-feather', 'download');
                        element.find(".fa-list").attr('data-feather', 'list');
                        element.find(".fa-trash").attr('data-feather', 'trash');
                        element.find(".fa-attach").attr('data-feather', 'paperclip');
                        // element.find(".fa-caret-up").attr('data-feather', 'chevron-up');
                        // element.find(".fa-caret-down").attr('data-feather', 'chevron-down');
                        // element.find(".fa-columns").attr('data-feather', 'columns');
                        try {
                            feather.replace({
                                width: 24,
                                height: 24,
                            });
                        } catch (e) {

                        }
                    };

                    const deregister1 = scope.$on('event:grid:' + scope.parentdiv, () => {
                        console.log('event:grid:' + scope.parentdiv);
                        caculateWidth("5", shouldIShrink);
                    });

                    const deregister2 = scope.$on('event:grid:refresh' + scope.parentdiv, (e, data) => {
                        console.log('<<===event:grid:refresh' + scope.parentdiv, data);
                        table.jqGrid('setGridParam', {
                            search: true,
                            postData: data
                        }).trigger('reloadGrid');
                        scope.filterData = data;
                    });

                    const deregister3 = scope.$on('event:grid:remove:filter' + scope.parentdiv, (e, data) => {
                        console.log('<<===event:grid:refresh' + scope.parentdiv, data);
                        // console.log(table.jqGrid('getGridParam').postData);
                        const postData = table.jqGrid('getGridParam').postData;
                        Object.keys(data).forEach(key => {
                            delete postData[key];
                        });
                        table.jqGrid('setGridParam', {
                            search: true,
                            postData
                        }).trigger('reloadGrid');
                        scope.filterData = postData;
                    });

                    $(window).bind('resize', function () {
                        caculateWidth("3", shouldIShrink);
                    });

                    scope.$on('$destroy', () => {
                        deregister1();
                        deregister2();
                        deregister3();
                    });

                    const obtogrid = new OBTOGridExtended(table, settings, scope, scope.table);

                    element.attr('id', wrapperId);
                    table.attr('id', tableId);

                    let pagerId = 'jqgrid-pager-' + gridNumber;
                    element.find('.jqgrid-pagination').attr('id', pagerId);

                    obto.dateSearchOptions = {
                        value: ":All;today:Today;yesterday:Yesterday;daybeforeyesterday:DayBeforeYesterday;tweek:This Week;lweek:Last Week;tmonth:This Month;lmonth:Last Month"
                    };
                    let twoMonthsBack = moment.tz().month() - 2,
                        threeMonthsBack = twoMonthsBack - 1,
                        fourMonthsBack = threeMonthsBack - 1;

                    obto.dateSearchOptions.value += ";" + twoMonthsBack + ":" + scope.months[twoMonthsBack];
                    obto.dateSearchOptions.value += ";" + threeMonthsBack + ":" + scope.months[threeMonthsBack];
                    obto.dateSearchOptions.value += ";" + fourMonthsBack + ":" + scope.months[fourMonthsBack];

                    console.log('scope.config', scope.config);

                    if (!_.isUndefined(scope.config)) {
                        defaultPageSize = scope.config.pagesize;
                        sortOrder = scope.config.sortorder || 'desc';
                        gridWidth = scope.config.gridwidth || 0;
                        sortName = scope.config.sortname || 'updated_on';
                        cellEditing = scope.config.editenabled || true;
                        filters = scope.config.filters || [];
                        isNavGridEnabled = scope.config.shownavGrid || true;
                        console.log('isNavGridEnabled', isNavGridEnabled);
                        if (!isNavGridEnabled) {
                            navAdd = false, navEdit = false, navDelete = false;
                            inlineNav = false;
                        }
                    }

                    if (scope.table === "fs.files") {
                        sortOrder = 'desc';
                        sortName = 'uploadDate';
                    }

                    const setUrlFilter = (postData) => {
                        if (Object.keys(postData).length !== 0) {
                            const filterData = scope.filterData;
                            $timeout(function () {
                                _.extend(filterData, postData);
                                $location.search(postData);
                            });
                        }
                    };

                    const cleanUnwantedParams = (postData) => {
                        delete postData['pagename'];
                        delete postData['filters'];
                        Object.keys(postData).forEach((key) => {
                            // console.log(typeof postData[key], key);
                            if (typeof postData[key] === "undefined" || postData[key] === null || postData[key] === "null")
                                delete postData[key];
                        });
                    };

                    let fileCb = (response) => {
                        var file = new Blob([response.data], {
                            type: 'application/pdf'
                        });
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(file); // for IE
                        } else {
                            var fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        }
                    };

                    scope.viewFile = (file) => {
                        "use strict";
                        // console.log(file);
                        swal({
                            title: "Are you sure?",
                            text: "You gotta do what you gotta do",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, download it!",
                            cancelButtonText: "No, cancel plz!"
                        }).then((result) => {
                            if (result.value) {
                                // console.log(result);
                                $http.get('/o/fs.files/' + file.id, {
                                    responseType: "arraybuffer"
                                }).then((response) => {
                                    saveAs(new Blob([response.data], {
                                        type: file.contype
                                    }), file.name);
                                    swal("Success", "File Downloaded :)", "success");
                                });
                            } else {
                                swal("Cancelled", "Your imaginary file is safe :)", "error");
                            }
                        });
                    };

                    let fileviewNewWindow = () => {
                        "use strict";
                        return (cellvalue, options, rowdata, action) => {
                            // console.log(rowdata)
                            return '<a href="/o/fs.files/' + rowdata._id + '" contype="' + rowdata.contentType + '" name="' + rowdata.filename + '" id="' + rowdata._id + '" onclick="angular.element(this).scope().viewFile(this);return false;">' + cellvalue + '</a>';
                        };
                    };

                    function isNumber(n) {
                        return !isNaN(parseFloat(n)) && isFinite(n);
                    }

                    scope.$watch('columnModel', function (n, o) {
                        if (n) {
                            pageService.getgridmodel(scope.table, scope.project, filters, function (_data) {
                                scope.gridData.colModel = _data.columnData;
                                scope.project = _.pluck(_data.columnData, 'name').join();
                                scope.onChangeFunction = _data.onChangeFunctions || [];
                                scope.onLoadFunction = _data.onLoadFunctions || [];
                                const listStructure = {};
                                listStructure[templateName] = {
                                    Filters: _data.filters || [],
                                    Actions: _data.actions || []
                                };

                                $ngRedux.dispatch({
                                    type: 'UPDATE',
                                    payload: {
                                        "lists": listStructure
                                    }
                                });
                                scope.gridData.colNames = _data.columns;
                                scope.gridData.config = _data.config || {};

                                if (!scope.gridData.config.list_create) {
                                    navAdd = false;
                                }

                                let newSequence = "",
                                    autoedit = false;
                                let lastPage = 1;
                                let totalColumnWidth = 0;

                                let modifiedColumnModel = scope.gridData.colModel;

                                async.each(modifiedColumnModel, function (col, cb) {

                                    totalColumnWidth += parseInt(col.width);

                                    if (col.name === "created_by" || col.name === "updated_by" || col.name === "updated_on" || col.name === "created_on") {
                                        col.editable = false;
                                    }

                                    col.colmenu = true;
                                    col.coloptions = {
                                        sorting: true,
                                        columns: true,
                                        filtering: false,
                                        searching: false,
                                        grouping: false,
                                        freeze: true
                                    };

                                    switch (col.input_type) {
                                        case "number":
                                            numbers.push(col.name);
                                            col.formatter = obtogrid.validatePositive();
                                            col.searchoptions = {
                                                searchOperMenu: true,
                                                sopt: ['eq', 'gt', 'lt', 'ge', 'le']
                                            };
                                            col.editoptions = {
                                                dataInit: function (elem) {
                                                    $(elem).focus(function () {
                                                        this.select();
                                                    });
                                                    setTimeout(function () {
                                                        // console.log($(elem)[0].value);
                                                        if ($(elem)[0].value !== "" && !isNumber($(elem)[0].value)) {
                                                            this.value = "";
                                                            this.focus();
                                                            alert("Please enter number only");
                                                        }
                                                    }, 100);
                                                },
                                                dataEvents: [{
                                                    type: 'change',
                                                    fn: function (e) {
                                                        let row = $(e.target).closest('tr.jqgrow');
                                                        let rowid = row.attr('id');
                                                        let row_values = table.jqGrid('getRowData', rowid);

                                                        if (!isNumber($(e.target).val())) {
                                                            this.value = "";
                                                            this.focus();
                                                            alert("Please enter number only");
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                        table.restoreRow(rowid);
                                                        let o = {
                                                            root: $rootScope,
                                                            scope: scope,
                                                            timeout: $timeout,
                                                            http: $http,
                                                            window: $window,
                                                            moment: moment,
                                                            _: _,
                                                            routeParams: $routeParams,
                                                            async: async,
                                                            modal: $uibModal,
                                                            API: API,
                                                            localStorage: $localstorage
                                                        };

                                                    }
                                                }]
                                            };
                                            cb();
                                            break;

                                        case "text":
                                            col.searchoptions = {
                                                searchOperMenu: true,
                                                sopt: ['eq', 'bw', 'bn', 'cn', 'nc', 'nu', 'nn']
                                            };
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatter = obtogrid.generalFormatter();
                                            col.frozen = true;
                                            col.sortable = true;
                                            col.editoptions = {
                                                dataInit: function (elem) {
                                                    $(elem).focus(function () {
                                                        this.select();
                                                    });
                                                }
                                            };
                                            cb();
                                            break;

                                        case "date":
                                            col.formatter = obtogrid.dateFormatter();
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.sorttype = "date";
                                            col.firstsortorder = "desc";
                                            col.formatoptions = {
                                                srcformat: 'd/m/Y',
                                                newformat: 'd/m/Y'
                                            };
                                            col.editoptions = {
                                                dataInit: (elem) => {

                                                    let _format = "dd-mm-yyyy";
                                                    let pickerFormat = $rootScope.globalAttributes['co.obto.domain.date.format'];
                                                    if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
                                                        _format = 'mm-dd-yyyy';

                                                    $(elem).focus(function () {
                                                        this.select();
                                                    });
                                                    $(elem).datepicker({
                                                        autoclose: true,
                                                        maxViewMode: 2,
                                                        todayBtn: "linked",
                                                        orientation: "auto bottom",
                                                        format: _format
                                                    });
                                                    $(elem).focus(function () {
                                                        this.select();
                                                    });
                                                }
                                            };
                                            // col.editoptions.dataInit = obtogrid.pickDate();
                                            col.searchoptions = {
                                                sopt: ['eq']
                                            };
                                            dt.push(col.name);
                                            cb();
                                            break;

                                        case "datetime":
                                            col.cellattr = obtogrid.dateTimeFormatterSetTitle();
                                            col.formatter = obtogrid.dateTimeFormatter();
                                            col.editrules = {
                                                required: true
                                            };
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatoptions = {
                                                srcformat: 'd/m/Y H:i',
                                                newformat: 'd/m/Y H:i'
                                            };
                                            col.editoptions = {
                                                dataInit: function (el) {
                                                    $(el).datetimepicker({
                                                        locale: 'en-US',
                                                        widgetPositioning: {
                                                            horizontal: 'auto',
                                                            vertical: 'auto'
                                                        },
                                                        widgetParent: $('#' + wrapperId)
                                                    });
                                                }
                                            };
                                            col.searchoptions = {
                                                sopt: ['eq'],
                                                dataInit: function (elem, options) {
                                                    //     console.log("options", options);
                                                    //     var self = this, $elem = $(elem),
                                                    //         filterOnSelect = function () {
                                                    //             console.log("options222", options);
                                                    //             setTimeout(function () {
                                                    //                 self.triggerToolbar();
                                                    //             }, 100);
                                                    //         },
                                                    //         triggerInputChangeOnSelect = function () {
                                                    //             console.log("options22233", options);
                                                    //             $elem.change();
                                                    //         };
                                                    //
                                                    //     setTimeout(function () {
                                                    //         $elem.datepicker({
                                                    //             dateFormat: "d-M-yy",
                                                    //             autoSize: true,
                                                    //             changeYear: true,
                                                    //             changeMonth: true,
                                                    //             showButtonPanel: true,
                                                    //             showWeek: true,
                                                    //             onSelect: function(date) {
                                                    //                 alert(date);
                                                    //             },//(options.oper === "search" ? filterOnSelect : triggerInputChangeOnSelect)
                                                    //         });
                                                    //     }, 500);
                                                    // }
                                                    // };
                                                }
                                            };
                                            dates.push(col.name);
                                            cb();
                                            break;

                                        case "mselect":
                                            col.formatter = function (cellValue, options, rowObject) {
                                                $log.debug(options);
                                                return cellValue;
                                            };
                                            // col.unformat = obtogrid.unFormatMReference();
                                            mreferences.push(col.name);
                                            if (!_.isUndefined(col.dependency) && col.dependency.length !== 0 && scope.columnOptions[col.name]) {
                                                col.editoptions = scope.columnOptions[col.name];
                                            }
                                            col.editoptions.dataInit = (element) => {
                                                // console.log(element);
                                                setTimeout(function () {
                                                    const configSimple = {
                                                        width: 'resolve',
                                                        placeholder: "Select an option"
                                                    };
                                                    let select2Box = $(element).select2(configSimple);
                                                    $(element).focus(function () {
                                                        // console.log("I am BS")
                                                    });
                                                }, 0);

                                            };
                                            col.editoptions.multiple = true;
                                            col.searchoptions = {
                                                sopt: ['eq', 'bw', 'bn', 'cn', 'nc']
                                            };

                                            cb();
                                            break;

                                        case "image":
                                            col.formatter = obtogrid.formatImage();
                                            col.unformat = obtogrid.imageUnFormat();
                                            col.searchoptions = {
                                                searchOperMenu: false
                                            };
                                            cb();
                                            break;

                                        case "option":
                                            col.formatter = obtogrid.optionFormatter();
                                            col.unformat = obtogrid.unformatOptions();
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            let ordered = ":[All];";

                                            // var sortable = [];
                                            for (let key in col.editoptions.value) {
                                                // sortable.push([key, col.editoptions.value[key]]);
                                                if (key !== "") {
                                                    ordered += key + ":" + col.editoptions.value[key] + ";";
                                                }

                                            }
                                            ordered = ordered.slice(0, -1);

                                            col.stype = "select";
                                            col.searchoptions = {
                                                searchOperMenu: true,
                                                sopt: ['eq', 'ne', 'bw', 'bn', 'cn', 'nc'],
                                                value: ordered //,
                                                // dataInit: function (element) {
                                                //     $(element).val(4);
                                                // }
                                            };

                                            if (!_.isUndefined(col.dependency) && col.dependency.length !== 0 && scope.columnOptions[col.name]) {
                                                col.editoptions = scope.columnOptions[col.name];
                                            }

                                            col.editoptions.dataInit = function (elem) {
                                                $(elem).focus(function () {
                                                    // this.select();
                                                });
                                            };
                                            cb();
                                            break;

                                        case "checkbox":
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.unformat = function (cellvalue, options, cellobject) {
                                                if (scope.table === "attendance") {
                                                    switch (cellvalue) {
                                                        case "P":
                                                            return "true";
                                                        case "A":
                                                            return false;
                                                        default:
                                                            return cellvalue ? cellvalue : false;
                                                    }
                                                }
                                                return cellvalue;
                                            };

                                            col.stype = "select";
                                            col.searchoptions = {
                                                searchOperMenu: false,
                                                value: ":All;true:True;false:False"
                                            };
                                            col.formatter = obtogrid.booleanFormatter();
                                            col.editoptions = {
                                                value: "true:false"
                                            };
                                            cb();
                                            break;

                                        case "gselect":
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatter = obtogrid.gselectFormatter(col.name, dataStore);
                                            col.unformat = obtogrid.unFormatReference();
                                            references.push(col.name);
                                            col.edittype = 'custom';
                                            col.editoptions = {};
                                            col.editoptions.dataInit = function (elem) {
                                                setTimeout(() => {
                                                    $('span > input').focus();
                                                }, 100);
                                            };
                                            //col.display_field, col.refer_collection, col.name, col.dependency
                                            col.editoptions.custom_element = obtogrid.autocomplete_element(col, storeId, $rootScope);
                                            col.editoptions.custom_value = obtogrid.autocomplete_value();
                                            col.searchoptions = {
                                                // dataInit: function (element) {
                                                //     const collection = col.refer_collection;
                                                //     const df = col.display_field;
                                                //     const n = col.name;
                                                //     const dependency = col.dependency;
                                                //     const sourceFilter = col.source_filter;
                                                //     let displayfield = df;
                                                //     let displayfieldGroup = "";
                                                //     let remainingProjection = "";
                                                //     let format = {};
                                                //
                                                //     if (df && df.toString().indexOf(',') > -1) {
                                                //         let split = df.split(',');
                                                //         displayfield = split[0];
                                                //         displayfieldGroup = split[1];
                                                //
                                                //     }
                                                //
                                                //     if (displayfieldGroup.length > 0)
                                                //         remainingProjection = ',' + displayfieldGroup;
                                                //
                                                //     setTimeout(() => {
                                                //         console.log($(element)[0], "$(element)");
                                                //
                                                //         $(element).autocomplete(
                                                //             {
                                                //                 source: function (request, response, term) {
                                                //                     const param = request.term; //values we enter to filter autocomplete
                                                //                     $.ajax({
                                                //                         url: `/o/recs/${collection}?stream=true&project=${displayfield}${remainingProjection}&oquery=${displayfield}==${param}`,
                                                //                         dataType: "json",
                                                //                         type: "GET",
                                                //                         beforeSend: function (jqXHR, settings) {
                                                //                             jqXHR.setRequestHeader("Authorization", 'Bearer ' + JSON.parse(localStorage.getItem("ob")).token);
                                                //                         },
                                                //                         success: function (data) {
                                                //                             //console.log(JSON.stringify(data));
                                                //                             // if (collection === 'pltf_user') {
                                                //                             //     let insertGlobalUser = {};
                                                //                             //     insertGlobalUser[displayfield] = 'Global';
                                                //                             //     insertGlobalUser._id = 'global';
                                                //                             //     data.push(insertGlobalUser);
                                                //                             // }
                                                //
                                                //
                                                //                             response($.map(data, function (item) {
                                                //                                 //console.log("typeof displayfieldGroup : " + displayfieldGroup)
                                                //                                 //console.log("value displayfieldGroup : " + JSON.stringify(item))
                                                //                                 // if (displayfieldGroup.length !== 0) {
                                                //                                 //
                                                //                                 //     if (typeof item[displayfieldGroup] === "object") {
                                                //                                 //         format = {
                                                //                                 //             //can add number of attributes here
                                                //                                 //             id: item._id,
                                                //                                 //             label: item[displayfield] + ' - ' + item[displayfieldGroup].label
                                                //                                 //         };
                                                //                                 //     } else {
                                                //                                 //         format = {
                                                //                                 //             //can add number of attributes here
                                                //                                 //             id: item._id,
                                                //                                 //             label: item[displayfield] + ' - ' + item[displayfieldGroup]
                                                //                                 //         };
                                                //                                 //     }
                                                //                                 //
                                                //                                 // } else {
                                                //                                 //     format = {
                                                //                                 //         //can add number of attributes here
                                                //                                 //         id: item._id,
                                                //                                 //         label: item[displayfield]
                                                //                                 //     };
                                                //                                 // }
                                                //                                 //
                                                //                                 // return format;
                                                //                             }));//END Response
                                                //
                                                //                         },//END Success
                                                //                     });//END AJAX
                                                //                 },
                                                //                 select: function (event, ui) {
                                                //                     storeId[n] = ui.item.id;
                                                //                 }
                                                //
                                                //             });
                                                //
                                                //     }, 3000);
                                                // },
                                                sopt: ['eq', 'bw', 'bn', 'cn', 'nc']
                                            };
                                            cb();
                                            break;

                                        case "url":
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatter = obtogrid.returnHyperLinkPage();
                                            col.unformat = (cellvalue, options, cell) => {
                                                return cellvalue;
                                            };
                                            cb();
                                            break;

                                        case "code":
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatter = obtogrid.scriptFormatter();
                                            col.unformat = obtogrid.unformatScriptFormatter;
                                            col.editable = false;

                                            col.unformat = function (cellvalue, options, cellobject) {
                                                return cellvalue;
                                            };
                                            col.searchoptions = {
                                                sopt: ['cn', 'nc', 'bw', 'bn']
                                            };
                                            cb();
                                            break;

                                        case "password":
                                            col.colmenu = true;
                                            col.coloptions = {
                                                sorting: true,
                                                columns: true,
                                                filtering: false,
                                                searching: false,
                                                grouping: false,
                                                freeze: true
                                            };
                                            col.formatter = obtogrid.password(); //'showlink';
                                            col.editable = true;
                                            col.unformat = function (cellvalue, options, cellobject) {
                                                return cellvalue; //cellobject.job_id;
                                            };
                                            col.editoptions = {};
                                            col.editoptions.dataInit = function (elem) {
                                                $(elem).focus(function () {
                                                    this.select();
                                                });
                                            };
                                            cb();
                                            break;

                                        default:
                                            cb();

                                    }
                                },

                                    function (err) {
                                        if (err) {
                                            throw err;
                                        }

                                        if (totalColumnWidth < $('#' + scope.parentdiv).width()) {
                                            shouldIShrink = true;
                                        }

                                        try {
                                            modifiedColumnModel[0].formatter = (scope.table === 'fs.files') ? fileviewNewWindow() : obtogrid.returnHyperLink(gridOptions, $rootScope);
                                            modifiedColumnModel[0].editable = false;
                                            modifiedColumnModel[0].frozen = true;
                                        } catch (e) {
                                            $log.error('grid-error: ' + e);
                                        }
                                    }
                                );


                                if (!_.isUndefined(scope.fvalue) && scope.fvalue.indexOf('@') > -1) { //Dashboard pages filter values
                                    scope.fvalue = scope.fvalue.substring(1, scope.fvalue.length);
                                    scope.fvalue = $routeParams[scope.fvalue];
                                }

                                let propgateFilter = true;

                                // Strips OBTO operator prefixes from filter values for display in toolbar
                                const stripOperatorPrefix = (val) => {
                                    if (typeof val !== 'string') return val;
                                    if (val.startsWith('!*')) return val.substring(2);
                                    if (val.startsWith('!=')) return val.substring(2);
                                    if (val.startsWith('<=')) return val.substring(2);
                                    if (val.startsWith('>=')) return val.substring(2);
                                    if (val.startsWith('*')) return val.substring(1);
                                    if (val.startsWith('!')) return val.substring(1);
                                    if (val.startsWith('<')) return val.substring(1);
                                    if (val.startsWith('>')) return val.substring(1);
                                    if (val.startsWith('=')) return val.substring(1);
                                    if (val === 'EMPTY' || val === 'NOTEMPTY') return '';
                                    return val;
                                };

                                // Restores filter toolbar input values from a filter data object
                                const restoreToolbarInputs = (filterSource) => {
                                    const gridParams = ['_search', 'nd', 'rows', 'page', 'sidx', 'sord', 'project', 'pagename', 'collection'];
                                    Object.keys(filterSource).forEach(key => {
                                        if (gridParams.includes(key)) return;
                                        const val = filterSource[key];
                                        if (val) {
                                            const input = element.find('#gs_' + key);
                                            if (input.length) {
                                                input.val(stripOperatorPrefix(val));
                                            }
                                        }
                                    });
                                };


                                let inlineEditOptions = {
                                    keys: true,
                                    oneditfunc: function (rowid) {
                                        //alert("row with rowid=" + rowid + " is editing.");
                                    },
                                    aftersavefunc: function (rowid, response, options) {
                                        table.trigger('reloadGrid', [{
                                            page: lastPage //table.getGridParam('page')//
                                        }]);
                                    }
                                };

                                scope.inlineConfig = {
                                    edit: false,
                                    add: false,
                                    useDefValues: true,
                                    addParams: {
                                        position: "last",
                                        addRowParams: inlineEditOptions,
                                        initdata: scope.filterData
                                    },
                                    editParams: inlineEditOptions
                                };

                                $.extend($.jgrid.inlineEdit, {
                                    keys: true,
                                    onEscape: (rowid, options, event) => {
                                        // console.log(rowid);
                                    }
                                });


                                // $.jgrid.defaults.width = $('#' + scope.parentdiv).width();
                                $.jgrid.defaults.responsive = true;
                                $.jgrid.defaults.styleUI = 'Bootstrap4';
                                $.jgrid.defaults.iconSet = "fontAwesome";

                                $("#savestate").click(() => {
                                    $.jgrid.saveState(tableId);
                                });

                                // $("#setFrozen").click(function () {
                                //     table.jqGrid('destroyFrozenColumns').jqGrid('setColProp', 'updated_on', { frozen: true }).jqGrid('setFrozenColumns').trigger('reloadGrid', [{ current: true }]); // optional
                                // });

                                $("#loadstate").click(() => {
                                    $.jgrid.loadState(tableId);
                                });

                                // $.jgrid.styleUI.Bootstrap.base.rowTable = "table table-bordered table-hover";

                                console.log('isMobile', isMobile);

                                if (isMobile) {
                                    $.jgrid.defaults.toppager = false;
                                    $.jgrid.defaults.responsive = true;
                                } else {
                                    $.jgrid.defaults.toppager = true;
                                    $.jgrid.defaults.responsive = false;
                                }

                                let currentSelectedColumn = -1;
                                let currentSelectedRow = -1;

                                const GLOBAL_SETTINGS = $localstorage.getObject("ob");
                                table.jqGrid({
                                    url: scope.dataUrl,
                                    datatype: "json",
                                    height: 'auto',
                                    colModel: modifiedColumnModel,
                                    rowNum: defaultPageSize,
                                    rowList: [defaultPageSize, 50, 75, 100, 200],
                                    toppager: true,
                                    pager: '#' + pagerId,
                                    sortable: true,
                                    sortname: sortName,
                                    sortorder: sortOrder,
                                    multiboxonly: true,
                                    multiselect: true,
                                    shrinkToFit: false,
                                    autowidth: false,
                                    autoencode: true,
                                    colMenu: true,
                                    recreateFilter: false,
                                    iconSet: "fontAwesome",
                                    shrinkToFit: false,
                                    autowidth: true,
                                    forceFit: false,
                                    // guiStyle: "bootstrap4",
                                    // grouping: true,
                                    // caption: "Custom Summary Type",
                                    // groupingView: {
                                    //     groupField: [],
                                    //     groupColumnShow: [true],
                                    //     groupText: ["<b>{0}</b>"],
                                    //     groupOrder: ["asc"],
                                    //     groupSummary: [true, true],
                                    //     groupCollapse: false,
                                    //     groupSummaryPos: ['header', 'header']
                                    //
                                    // },
                                    jsonReader: {
                                        repeatitems: false
                                    },
                                    cellEdit: cellEditing,
                                    cellsubmit: 'remote',
                                    cellurl: '/o/' + scope.table,
                                    toolbarfilter: true,
                                    viewrecords: true,
                                    hoverrows: true,
                                    clearSearch: true,
                                    headertitles: true,
                                    footerrow: true,
                                    userDataOnFooter: true,
                                    ajaxGridOptions: {
                                        contentType: 'application/json',
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    ajaxAddOptions: {
                                        contentType: "application/json",
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    ajaxRowOptions: {
                                        contentType: "application/json; charset=utf-8",
                                        // dataType: "json",
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    ajaxCellOptions: {
                                        contentType: "application/json",
                                        // dataType: "json",
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    editurl: "/o/" + scope.table,
                                    afterSubmitCell: function (response, rowid, cellname, value, iRow, iCol) {
                                        $log.debug("response 2: " + JSON.stringify(response));
                                        oldValue = "";
                                        if (_ids.length > 1) {
                                            table.trigger('reloadGrid', [{
                                                page: lastPage
                                            }]);
                                        }
                                        _ids = [];

                                        if (response.status === 200) {
                                            return [true, "success"];
                                        }
                                        return [false, "failed"];

                                    },

                                    errorCell: function (response, status) {
                                        swal("Problem", response.responseText || "Something is not right.", "error");
                                    },

                                    beforeSubmitCell: function (rowid, cellname, value, iRow, iCol) {
                                        let token = _data.csrf;
                                        return {
                                            _csrf: token,
                                            _id: table.jqGrid("getCell", rowid, "_id"),
                                            domain: table.jqGrid("getCell", rowid, "domain") || $rootScope.domain,
                                            _oldValue: oldValue,
                                            _ids: _ids,
                                            gselectid: JSON.stringify(storeId2)
                                        };
                                    },

                                    beforeSaveCell: function (rowid, cellname, value, iRow, iCol) {
                                        let newvalue = value; //{}
                                        let _format = "DD-MM-YYYY";
                                        let pickerFormat = $rootScope.globalAttributes['co.obto.domain.date.format'];
                                        if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
                                            _format = 'MM-DD-YYYY';


                                        if (_.has(storeId2, cellname)) //If exists delete it first
                                            delete storeId2[cellname];

                                        _.each(dates, function (key) {
                                            if (cellname === key) {
                                                newvalue = moment.tz(value, $rootScope.globalAttributes['co.obto.domain.datetime.format']).toISOString();

                                            }
                                        });

                                        _.each(dt, function (key) {
                                            if (cellname === key) {
                                                newvalue = moment.tz(value, _format, $rootScope.timezone).startOf('day').toISOString();

                                            }
                                        });

                                        _.each(references, function (key) {
                                            if (cellname === key) {
                                                storeId2[cellname] = storeId[cellname];
                                            }
                                        });

                                        _.each(mreferences, function (key) {
                                            if (cellname === key) {
                                                storeId4[cellname] = storeId3[cellname];
                                            }
                                        });

                                        return newvalue;
                                    },

                                    beforeEditCell: function (rowid, cellname, value, iRow, iCol) {
                                        oldValue = value;
                                        selICol = iCol;
                                        selIRow = iRow;
                                        currentRow = iRow;
                                    },

                                    formatCell(rowid, cellname, value, iRow, iCol) {
                                        return value;
                                    },

                                    // beforeSelectRow: function (rowid, e) {
                                    //     let $self = $(this),
                                    //         iCol, cm,
                                    //         $td = $(e.target).closest("tr.jqgrow>td"),
                                    //         $tr = $td.closest("tr.jqgrow"),
                                    //         p = $self.jqGrid("getGridParam");

                                    //     if ($(e.target).is("input[type=checkbox]") && $td.length > 0) {
                                    //         iCol = $.jgrid.getCellIndex($td[0]);
                                    //         cm = p.colModel[iCol];
                                    //         if (cm != null && cm.name === "cb") {
                                    //             // multiselect checkbox is clicked
                                    //             $self.jqGrid("setSelection", $tr.attr("id"), true, e);
                                    //         }
                                    //     }
                                    //     return true;
                                    // },
                                    onCellSelect: function (rowId, iCol, content, event) {
                                        //YOUR STUFF
                                        // alert(rowId);
                                    },
                                    ondblClickRow: function (rowid, iRow, iCol, e) {
                                        // alert(rowId);
                                        $rootScope.$emit("event.remove.subform.modal", {
                                            collection: scope.table,
                                            _id: table.jqGrid("getCell", rowid, "_id")
                                        });
                                    },
                                    loadComplete: function (d) {
                                        _ids = [];
                                        lastSel = null;
                                        NProgress.done();
                                        lastPage = table.getGridParam('page');
                                        // fixPositionsOfFrozenDivs.call(this);
                                        let ids = table.jqGrid('getDataIDs');
                                        for (let i = 0; i < ids.length; i++) {
                                            let id = ids[i];
                                            try {
                                                let active = table.jqGrid('getCell', id, 'active');

                                                if (typeof active === "undefined" || active.toString() === "false") {
                                                    table.jqGrid('setCell', id, 'active', '', 'obto-grid-custom-lr2');
                                                }
                                                if (scope.table === "attendance") {
                                                    if (table.jqGrid('getCell', id, 'comment').indexOf('On Leave. Refer #LR') > -1) {
                                                        table.jqGrid('setCell', id, 'present', '', 'not-editable-cell');
                                                        table.jqGrid('setCell', id, 'present', '', 'obto-grid-custom-lr');
                                                    }
                                                    if (table.jqGrid('getCell', id, 'present') === false && table.jqGrid('getCell', id, 'comment').indexOf("On Leave. Refer #LR") === -1) {
                                                        table.jqGrid('setCell', id, 'present', '', 'obto-grid-custom-lr2');
                                                    }
                                                }
                                                if (scope.table === "result") {
                                                    if (table.jqGrid('getCell', id, 'class').indexOf('KG') > -1) {
                                                        table.jqGrid('setCell', id, 'present', '', 'not-editable-cell');
                                                        table.jqGrid('setCell', id, 'present', '', 'obto-grid-custom-lr');
                                                    }
                                                    if (table.jqGrid('getCell', id, 'present') === false && table.jqGrid('getCell', id, 'comment').indexOf("On Leave. Refer #LR") === -1) {
                                                        table.jqGrid('setCell', id, 'present', '', 'obto-grid-custom-lr2');
                                                    }
                                                }

                                            } catch (e) {
                                                console.log(e);
                                            }

                                            // table.jqGrid('groupingRemove',true);
                                            //     table.jqGrid('groupingGroupBy','name');
                                        }

                                        if (isMobile) {
                                            $("div.ui-pager-control > table > tbody > tr").children().addClass("obto-jqgrid-mobile");
                                        }

                                        const contextMenuItens = {
                                            "edit": {
                                                name: "Edit",
                                                icon: "fa-pencil"
                                            },
                                            "add": {
                                                name: "Create",
                                                icon: "fa-paste"
                                            },
                                            "addoptions": {
                                                name: "Field Options",
                                                icon: "fa-paste"
                                            },
                                            "showsimilar": {
                                                name: "Show Similar",
                                                icon: "fa-random"
                                            },
                                            "filterout": {
                                                name: "Filter Out",
                                                icon: "fa-filter"
                                            },
                                            "documentid": {
                                                name: "Copy ID",
                                                icon: "fa-file"
                                            },
                                            "viewjson": {
                                                name: "View JSON",
                                                icon: "fa-paste"
                                            },
                                            "copylink": {
                                                name: "Copy Link",
                                                icon: "fa-clipboard"
                                            },
                                            "copyinsert": {
                                                name: "Copy & Insert",
                                                icon: "fa-paste"
                                            },
                                            "exportjson": {
                                                name: "Export JSON",
                                                icon: "fa-paste"
                                            },
                                            "csvexport": {
                                                name: "Export CSV",
                                                icon: "fa-paste"
                                            },
                                            // "visualize": {name: "Visualize", icon: "fa-bar-chart"},
                                            "sep1": "---------",
                                            "delete": {
                                                name: "Delete",
                                                icon: "fa-trash-o"
                                            }
                                        };

                                        if (scope.table === 'deleted') {
                                            contextMenuItens["restore"] = {
                                                name: "Restore",
                                                icon: "fa-link"
                                            };
                                        }

                                        table.click(function (e) {
                                            var el = e.target;
                                            if (el.nodeName !== "TD") {
                                                el = $(el, this.rows).closest("td");
                                            }
                                            currentSelectedColumn = $(el).index();
                                            var nCol = $(el).siblings().length;
                                            var row = $(el, this.rows).closest("tr.jqgrow");
                                            currentSelectedRow = row[0].id;
                                            // alert ("The column with the number "+currentSelectedColumn+" in the row with the rowId='"+currentSelectedRow+"' was clicked");
                                        });

                                        $.contextMenu('destroy', 'tr.jqgrow>td');
                                        $.contextMenu({
                                            selector: 'tr.jqgrow>td',
                                            callback: function (key, options, event) {
                                                // var m = "clicked: " + key;
                                                // console.log(event.$trigger[0]);
                                                // console.log($(event.$trigger).parent()[0].id);
                                                // console.log($('#' + event.$trigger[0].id).closest('td').attr('aria-describedby'));
                                                // console.log('options', options);
                                                const trigger = event.$trigger;
                                                const currentRowId = $(trigger[0]).parent()[0].id;
                                                let columnParts = [];
                                                try {
                                                    columnParts = $(trigger[0]).attr('aria-describedby').split('_');
                                                } catch (e) {

                                                }
                                                const columnName = columnParts[1] + (columnParts[2] ? '_' + columnParts[2] : '') + (columnParts[3] ? '_' + columnParts[3] : '');
                                                const rowUri = scope.table + "/" + currentRowId;//table.jqGrid("getCell", currentRowId, "_id");

                                                if (options === 'edit') {
                                                    location.href = rowUri;
                                                }

                                                if (options === 'add') {
                                                    location.href = scope.table + "/new";
                                                }

                                                if (options === 'copyinsert') {
                                                    customButtonClicked();
                                                }

                                                if (options === 'documentid') {
                                                    new CopyClipBoard().copy(currentRowId);
                                                    // new ClipboardJS('.fa-file', {
                                                    //     text: function () {
                                                    //         return currentRowId;
                                                    //     }
                                                    // });
                                                }


                                                if (options === 'csvexport') {
                                                    downloadTemplate();
                                                }

                                                if (options === 'addoptions') {

                                                    const data = {
                                                        collection: 'pltf_option',
                                                        type: "list",
                                                        filter: { field: columnName, collection: scope.table }
                                                    };
                                                    // console.log('addoptions', data);
                                                    $rootScope.openv3('fieldoptions', null, data);
                                                }

                                                if (options === 'viewjson') {
                                                    let jsonViewCb = async (response) => {

                                                        "use strict";
                                                        let newWindow = window.open();

                                                        //write the data to the document of the newWindow
                                                        // const formatted = bjs(JSON.stringify(response.data), {
                                                        //     indent_size: 2,
                                                        //     indent_char: " "
                                                        // });

                                                        const formatted = await format(JSON.stringify(response.data), {
                                                            parser: "babel",
                                                            plugins: [prettierPluginBabel, prettierPluginEstree],
                                                            jsxBracketSameLine: true
                                                        });

                                                        $timeout(() => {
                                                            newWindow.document.write('<pre style="overflow: auto;background: darkslateblue;\n' +
                                                                '    color: white;\n' +
                                                                '    padding: 30px;">' + formatted + '</pre>');
                                                        }, 100);


                                                    };
                                                    $http.get('/jsonexport/' + scope.table + '/' + currentRowId, {}).then(jsonViewCb);
                                                }

                                                if (options === 'exportjson') {
                                                    "use strict";
                                                    let jsonCb = (response) => {

                                                        saveFile(scope.table + ".json", "data:attachment/json", response.data);
                                                    };

                                                    swal({
                                                        title: "Are you sure?",
                                                        text: "You gotta do what you gotta do",
                                                        type: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#DD6B55",
                                                        confirmButtonText: "Yes, download it!",
                                                        cancelButtonText: "No, cancel plz!"
                                                    }).then((result) => {
                                                        if (result.value) {
                                                            $http.get('/jsonexport/' + scope.table + '?' + scope.requestQueryParams, {
                                                                responseType: "arraybuffer"
                                                            }).then(jsonCb);
                                                            swal("Success", "Your file is open right next window :)", "success");
                                                        } else {
                                                            swal("Cancelled", "Your imaginary file is safe :)", "error");
                                                        }
                                                    });
                                                }

                                                if (options === 'restore') {
                                                    restoreDeleted();
                                                }

                                                if (options === 'filterout') {
                                                    const setFilterData = {};
                                                    const postData = $(this).jqGrid("getGridParam", "postData");
                                                    _.extend(setFilterData, $routeParams, postData);
                                                    setFilterData[columnName] = '!' + trigger[0].title;
                                                    table.jqGrid('setGridParam', {
                                                        search: true,
                                                        postData: setFilterData
                                                    }).trigger('reloadGrid');
                                                    scope.filterData = setFilterData;
                                                    if (!embedded) {
                                                        $location.search(setFilterData);
                                                    }
                                                }

                                                if (options === 'showsimilar') {
                                                    const setFilterData = {};
                                                    const lookupValue = trigger[0].title ? trigger[0].title : 'EMPTY';
                                                    setFilterData[columnName] = lookupValue;
                                                    table.jqGrid('setGridParam', {
                                                        search: true,
                                                        postData: setFilterData
                                                    }).trigger('reloadGrid');
                                                    scope.filterData = setFilterData;
                                                    if (!embedded) {
                                                        $location.search(setFilterData);
                                                    }
                                                }

                                                if (options === 'search') {
                                                    table.jqGrid("searchGrid", {
                                                        a: 1
                                                    });
                                                }

                                                if (options === 'copylink') {
                                                    new CopyClipBoard().copy(`${window.location.protocol}//${$rootScope.domain}.obto.co/o/${rowUri}`);
                                                    // new ClipboardJS('.fa-clipboard', {
                                                    //     text: function () {
                                                    //         return `${window.location.protocol}//${$rootScope.domain}.obto.co/o/${rowUri}`;
                                                    //     }
                                                    // });
                                                }
                                                if (options === 'delete') {
                                                    if ($('#del').hasClass('ui-state-disabled') === false) {
                                                        grid.delGridRow(trigger.id, deleteSettings);
                                                    }
                                                }
                                            },
                                            items: contextMenuItens
                                        });

                                        try {
                                            $timeout(() => {
                                                $rootScope.$emit("event.render.subform.completed");
                                            }, 500);
                                        } catch (e) {

                                        }


                                    },
                                    onSelectRow: function (id, status) {
                                        console.log(id, status);
                                        if (!status) {
                                            _ids = _.reject(_ids, (_this) => {
                                                return _this === id;
                                            });
                                            return;
                                        }

                                        if (status && id && id === lastSel) {
                                            return;
                                        }

                                        if (status && id && id !== lastSel) {
                                            table.jqGrid('restoreRow', lastSel);
                                            lastSel = id;
                                            _ids.push(id);
                                        }

                                    },
                                    onSelectAll: function (id, status) {
                                        // console.log(id instanceof Array);
                                        _ids = [];
                                        if (!status) {
                                            _ids = [];
                                            return status;
                                        }

                                        _ids = id;

                                    },
                                    serializeRowData: function (postData) {
                                        postData.domain = table.jqGrid("getCell", 1, "domain") || $rootScope.domain;
                                        _.each(postData, function (value, key, list) {
                                            if (_.contains(dates, key)) {
                                                postData[key] = moment.tz(postData[key]).toISOString();
                                            }

                                            if (_.contains(references, key)) {
                                                storeId2[key] = storeId[key];
                                                postData.gselectid = storeId2;

                                            }
                                        });

                                        //Needs to be simplified as cell serialization
                                        return JSON.stringify({
                                            oper: postData.oper,
                                            data: postData,
                                            _csrf: token,
                                            _id: postData._id
                                        });
                                    },

                                    serializeCellData: function (postdata) {
                                        delete postdata.id;
                                        return JSON.stringify(postdata);
                                    },

                                    beforeRequest: function () {
                                        NProgress && NProgress.start();

                                        let $self = $(this),
                                            postData = $self.jqGrid("getGridParam", "postData"),
                                            newPost = {};

                                        // Preserve existing postData (toolbar filters, event-based filters, etc.)
                                        _.extend(newPost, postData);

                                        if (typeof scope.filter !== "undefined" && typeof scope.filter === 'string') {
                                            filter = scope.filter;
                                            propgateFilter = false;
                                            let justTheFilterValue = {};
                                            justTheFilterValue[filter] = scope.fvalue;

                                            _.extend(newPost, justTheFilterValue);
                                        }

                                        if (typeof scope.filter !== "undefined" && Object.keys(scope.filter).length !== 0 && propgateFilter) { //Dashboard pages filter values

                                            propgateFilter = false;
                                            newPost._search = true;
                                            _.extend(newPost, scope.filter);

                                        }

                                        if (typeof $routeParams !== "undefined" && Object.keys($routeParams).length !== 0 && propgateFilter) {

                                            if ($routeParams.collection === scope.table)
                                                delete $routeParams.collection;

                                            _.extend(newPost, $routeParams);

                                            _.each(newPost, function (val, key, list) {
                                                if (val && val.length === 0) {
                                                    delete newPost[key];
                                                }
                                            });

                                            if (!embedded) {
                                                setUrlFilter(newPost);
                                            }

                                            propgateFilter = false;
                                        }

                                        if ($rootScope.ob.eduCollections && $rootScope.ob.eduCollections.includes(scope.table)) {
                                            try {
                                                if (newPost.session) {
                                                    delete newPost.session;
                                                }
                                                newPost.session = "";
                                            } catch (e) {
                                                newPost.session = "";
                                            }
                                            newPost.session = $localstorage.getObject("ob.edu").session || $rootScope.ob.session;
                                        }

                                        newPost.project = scope.project;

                                        try {
                                            cleanUnwantedParams(newPost);
                                        } catch (e) {

                                        }

                                        table.jqGrid('setGridParam', {
                                            postData: newPost
                                        });
                                        return true;
                                    }
                                });


                                const _beforeSearch = function () {
                                    let postData = table.jqGrid('getGridParam', 'postData');
                                    let filterData = {};

                                    let holdFilter = {};
                                    _.extend(holdFilter, JSON.parse(postData.filters));

                                    delete postData.filters;
                                    _.each(holdFilter.rules, function (e, i, list) {
                                        "use strict";
                                        postData[e.field] = scope.obtoSearchMap[e.op] + e.data;
                                    });

                                    if (Object.keys(postData).length !== 0) {
                                        _.extend(filterData, postData);
                                    } else {
                                        filterData = {};
                                    }

                                    try {
                                        cleanUnwantedParams(filterData);
                                    } catch (e) {

                                    }

                                    if (!embedded) {
                                        $location.search(filterData);
                                    }

                                    $log.info('Filtered Data : ' + JSON.stringify(filterData));
                                    scope.filterData = filterData;
                                    if (!scope.$$phase && !scope.$root.$$phase) {
                                        scope.$apply();
                                    }
                                };

                                console.log('searchEnabled', searchEnabled);

                                if (searchEnabled) {
                                    table.jqGrid('filterToolbar', {
                                        searchOnEnter: true,
                                        enableClear: true,
                                        beforeSearch: _beforeSearch,
                                        searchOperators: true,
                                        stringResult: true,
                                        afterClear: function () {
                                            scope.filterData = {};
                                            if (!embedded) {
                                                $location.search({});
                                            }
                                            try {
                                                if (!scope.$$phase && !scope.$root.$$phase) {
                                                    scope.$apply();
                                                }
                                            } catch (e) {}
                                        }
                                    });
                                    toolbarReady = true;
                                }

                                table.jqGrid('bindKeys');

                                $.extend($.jgrid.search, {
                                    jqModal: false
                                });

                                let navOptions = { //navbar options
                                    cloneToTop: true,
                                    edit: false, //true,
                                    //editicon : 'ui-pg-button ui-corner-all',
                                    add: navAdd, //true,
                                    //addicon : 'ui-pg-button ui-corner-all',
                                    del: navDelete, //true,
                                    //delicon : 'ui-pg-button ui-corner-all',
                                    search: false,
                                    //searchicon : 'ui-pg-button ui-corner-all',
                                    refresh: true,
                                    //refreshicon : 'ui-pg-button ui-corner-all',
                                    view: false //,
                                    //viewicon : ' fa fa-search-plus grey',
                                };

                                const addSettings = {
                                    //new record form
                                    closeAfterAdd: true,
                                    recreateForm: true,
                                    viewPagerButtons: false,
                                    closeOnEscape: true,
                                    top: Math.floor($("#genericlistview").innerHeight / 2 - 300),
                                    left: Math.floor(window.innerWidth / 2 - 200),
                                    width: '500',
                                    height: '100%',
                                    url: '/o/' + scope.table + '/new',
                                    ajaxEditOptions: {
                                        contentType: 'application/json',
                                        timeout: 3000,
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    onInitializeForm: function (form) {
                                        form.find('.FormElement[obto-date]').datetimepicker().end();
                                    },
                                    beforeShowForm: function (e) {

                                        let form = $(e[0]);

                                        form.removeClass('FormGrid').addClass('form-horizontal');
                                        // console.log(scope.gridData.colModel);
                                        _.each(scope.gridData.colModel, (val) => {

                                            if (typeof val.form_view === "undefined" || !val.form_view) {
                                                form.find(`#tr_${val.name}`).css('display', 'none');
                                            }

                                            if (typeof val.mandatory === "undefined" || !val.mandatory) {
                                                form.find(`#tr_${val.name}`).css('display', 'none');
                                            }

                                            if (val.mandatory) {
                                                table.jqGrid('setColProp', val.name, { editrules: { required: true } });
                                            }
                                        });

                                        form.closest('.ui-jqdialog').wrapInner('<div class="modal-content" />');
                                        form.closest('.ui-jqdialog').removeClass('modal-content');//.addClass('modal-dialog');
                                        form.closest('.ui-jqdialog').find('.ui-jqdialog-titlebar').removeClass('ui-jqdialog-titlebar');

                                        $http.get("/o/sequence.bto/" + scope.table).then(function (response) {
                                            newSequence = response.data.value;
                                        });
                                    },
                                    serializeEditData: function (postData) {
                                        postData.sequence = newSequence;

                                        if ($rootScope.ob.eduCollections && $rootScope.ob.eduCollections.includes(scope.table)) {
                                            postData.session = $localstorage.getObject("ob.edu").session || $rootScope.ob.session;
                                        }

                                        let _format = "DD-MM-YYYY";
                                        let pickerFormat = $rootScope.globalAttributes['co.obto.domain.date.format'];
                                        if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
                                            _format = 'MM-DD-YYYY';

                                        postData.gselectid = {};

                                        _.each(postData, function (val, key) {

                                            if (_.contains(dates, key)) {
                                                postData[key] = moment.tz(val, $rootScope.timezone).toISOString();
                                            }

                                            if (_.contains(dt, key)) {
                                                postData[key] = moment.tz(val, _format, $rootScope.timezone).startOf('day').toISOString();
                                            }

                                            if (_.contains(references, key)) {
                                                postData.gselectid[key] = storeId[key];
                                            }
                                        });

                                        postData.domain = $rootScope.domain;
                                        return JSON.stringify(postData);
                                    }
                                };

                                const editSettings = {
                                    //edit record form
                                    closeAfterEdit: true,
                                    recreateForm: true,
                                    onInitializeForm: function (form) {
                                        form.find('.FormElement[obto-date]').datetimepicker().end();
                                    },
                                    beforeShowForm: function (e) {
                                        let form = $(e[0]);

                                        form.closest('.ui-jqdialog').find('.ui-jqdialog-titlebar').wrapInner('<div class="widget-header" />');
                                        style_edit_form(form);
                                    },
                                    serializeEditData: function (postData) {
                                        let ids = postData.id.split(','),
                                            i, l = ids.length,
                                            reqIDList = [];

                                        for (i = 0; i < l; i++) {
                                            reqIDList.push($(this).jqGrid("getCell", ids[i], "_id"));
                                        }

                                        if ($rootScope.ob.eduCollections && $rootScope.ob.eduCollections.includes(scope.table)) {
                                            postData.session = $localstorage.getObject("ob.edu").session || $rootScope.ob.session;
                                        }

                                        _.each(postData, function (key) {
                                            if (_.contains(dates, key)) {
                                                postData[key] = moment.tz(postData[key]).toISOString();
                                                //console.log(postData[key])
                                            }
                                        });

                                        postData.domain = table.jqGrid("getCell", ids[0], "domain") || $rootScope.domain;
                                        NProgress.start();
                                        return JSON.stringify({
                                            oper: postData.oper,
                                            _id: reqIDList.join(),
                                            data: postData,
                                            _csrf: token
                                        });
                                    }
                                };

                                const deleteSettings = {
                                    //delete record form
                                    // recreateForm: true,
                                    zIndex: 1051,
                                    mtype: 'POST',
                                    //reloadAfterSubmit: true,
                                    ajaxDelOptions: {
                                        // contentType: "application/json; charset=utf-8",
                                        beforeSend: function (jqXHR, settings) {
                                            jqXHR.setRequestHeader("Authorization", 'Bearer ' + GLOBAL_SETTINGS.token);
                                            jqXHR.setRequestHeader("Current-Session", $localstorage.getObject("ob.edu").session || $rootScope.ob.session);
                                            jqXHR.setRequestHeader("Current-Domain", GLOBAL_SETTINGS.domain || $rootScope.ob.domain);
                                        }
                                    },
                                    beforeShowForm: function (e) {
                                        // console.log($(e[0]))
                                        let form = $(e[0]);
                                        if (form.data('styled')) return false;
                                        form.closest('.ui-jqdialog').find('.ui-jqdialog-titlebar').wrapInner('<div style="padding: 10px;" class="widget-header" />');
                                        let buttons = form.next().find('.EditButton .fm-button');
                                        buttons.addClass('btn btn-sm').find('[class*="-icon"]').remove();
                                        buttons.eq(0).addClass('btn-danger');
                                        buttons.eq(1).addClass('obto-cancel');


                                        buttons.eq(0).find('span').remove();
                                        buttons.eq(0).append('<i class=""><!-- --></i>');
                                        buttons.eq(0).find('i').attr('data-feather', 'trash-2');


                                        buttons.eq(1).find('span').remove();
                                        buttons.eq(1).append('<i class=""/>');
                                        buttons.eq(1).find('i').attr('data-feather', 'refresh-cw');
                                        form.data('styled', true);
                                        feather.replace({
                                            width: 18,
                                            height: 18,
                                        });
                                    },
                                    afterComplete: function (response, postdata, formid) {

                                        swal("Success", "Selected records have been deleted", "success");
                                        setTimeout(() => {
                                            table.trigger('reloadGrid', [{
                                                page: lastPage
                                            }]);
                                        }, 500);
                                    },
                                    serializeDelData: function (postdata) {

                                        let ids = postdata.id.split(','),
                                            i, l = ids.length,
                                            reqIDList = [];

                                        postdata.domain = $(this).jqGrid("getCell", ids[0], "domain");

                                        if (!postdata.domain) {
                                            postdata.domain = $rootScope.domain;
                                        }

                                        const dlimit = 100;

                                        if ($rootScope.ob.user.roles.indexOf('delete') === -1 && $rootScope.ob.user.roles.indexOf('support_admin') === -1) {
                                            return swal("Problem", `You are not authorized to delete any records`, "error");
                                        }

                                        if ($rootScope.ob.user.roles.indexOf('super') === -1 && _ids.length > dlimit) {
                                            return swal("Problem", `You are not authorized to delete more than ${dlimit} records`, "error");
                                        }

                                        for (i = 0; i < l; i++) {
                                            reqIDList.push($(this).jqGrid("getCell", ids[i], "_id"));
                                            table.jqGrid('delRowData', ids[i]);
                                        }
                                        //Don't stringify deletes
                                        return {
                                            oper: postdata.oper,
                                            _id: reqIDList.join(),
                                            domain: postdata.domain,
                                            _csrf: token
                                        };
                                    },
                                    closeAfterAdd: true,
                                    jqModal: false,
                                    recreateForm: true,
                                    closeOnEscape: true,
                                    top: Math.floor($("#genericlistview").innerHeight / 2 - 300),
                                    left: Math.floor(window.innerWidth / 2 - 200),
                                    width: 400,
                                    height: '100%',
                                    beforeSubmit: function (ids, formid) {

                                        const finalLimit = 100;

                                        if ($rootScope.ob.user.roles.indexOf('delete') === -1 && $rootScope.ob.user.roles.indexOf('support_admin') === -1) {
                                            swal("Problem", `You are not authorized to delete any records`, "error");
                                            return [false, `You are not authorized to delete any records`];
                                        }

                                        if ($rootScope.ob.user.roles.indexOf('super') === -1 && _ids.length > finalLimit) {
                                            swal("Problem", `You are not authorized to delete more than ${finalLimit} records`, "error");
                                            return [false, `You are not authorized to delete more than ${finalLimit} records`];
                                        }

                                        return [true, "continue"];
                                    },
                                    errorTextFormat: function (response) {

                                        if (response.status !== '200') {
                                            return swal("Problem", response.responseText || "Something is not right.", "error"); //'error: ' + response.responseText;
                                        } else {
                                            return swal("Success", response.responseText, "success"); //'Save ok!'
                                        }
                                    }
                                };

                                $.extend($.jgrid.search, {
                                    multipleSearch: true,
                                    multipleGroup: true,
                                    recreateFilter: true,
                                    closeOnEscape: true,
                                    closeAfterSearch: true,
                                    overlay: 0
                                });

                                table.jqGrid('navGrid', '#' + pagerId,
                                    navOptions, editSettings, addSettings, deleteSettings, {
                                    multipleSearch: false
                                }
                                );

                                // add first custom button

                                !embedded && table.navButtonAdd('#' + pagerId, {
                                    buttonicon: "fa fa-lg fa-copy",
                                    title: "Copy Insert",
                                    caption: "",
                                    position: "last",
                                    onClickButton: customButtonClicked
                                });

                                !embedded && table.navButtonAdd('#jqgrid-table-' + gridNumber + '_toppager', {
                                    buttonicon: "fa fa-lg fa-copy",
                                    title: "Copy Insert",
                                    caption: "",
                                    position: "last",
                                    onClickButton: customButtonClicked
                                });

                                !embedded && table.navButtonAdd('#' + pagerId, {
                                    buttonicon: "fa fa-lg far fa-file-excel",
                                    title: "CSV Export",
                                    caption: "",
                                    position: "last",
                                    onClickButton: downloadTemplate
                                });

                                !embedded && table.navButtonAdd('#' + pagerId, {
                                    caption: "",
                                    buttonicon: "fa fa-lg fa-list",
                                    title: "Choose columns",
                                    onClickButton: function () {
                                        $.jgrid.defaults.multiselect = false;
                                        table.jqGrid('columnChooser', {
                                            done: function (perm) {
                                                if (perm) {
                                                    console.log('perm', table.jqGrid("getGridParam").colModel);
                                                    // this.jqGrid("remapColumns", perm, true);
                                                    // saveColumnState.call(this, perm);
                                                    // $.jgrid.defaults.multiselect = true;
                                                    const cols = table.jqGrid('getGridParam', "colModel");
                                                    const colChosen = [];
                                                    for (let i = 0; i < cols.length; i++) {
                                                        if (!cols[i]['hidden']) {
                                                            colChosen.push(cols[i]);
                                                        }
                                                    }
                                                    console.log("colChosen", colChosen);

                                                }
                                            }
                                        });
                                    }
                                });

                                function downloadTemplate() {

                                    let allRowsInGrid = table.jqGrid('getRowData');
                                    console.log(allRowsInGrid);
                                    export_data_to_csv(allRowsInGrid, scope.table + ".csv");

                                }

                                let copied = {};


                                function isAnchor(str) {
                                    return /^\<a.*\>.*\<\/a\>/i.test(str);
                                }

                                const restoreDeleted = (id) => {
                                    console.log(_ids);
                                };

                                function customButtonClicked() {
                                    copied = {};
                                    if (_ids.length === 0) {
                                        return swal("Problem", "Please select one row to copy :)", "warning");
                                    }

                                    if (_ids.length > 1) {
                                        return swal("Problem", "Come'on! Don't be that hard working. One is enough.", "error");
                                    }

                                    let _format = "dd-mm-yyyy";
                                    const pickerFormat = $rootScope.globalAttributes['co.obto.domain.date.format'];
                                    if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
                                        _format = 'mm-dd-yyyy';

                                    const rowdata = table.jqGrid('getRowData', _ids[0]);

                                    copied = angular.copy(rowdata);
                                    copied['oper'] = "add";
                                    copied['domain'] = $rootScope.domain;
                                    const rowId = copied._id;
                                    delete copied._id;
                                    copied = _.each(copied, (_val, key) => {

                                        if (isAnchor(_val)) {
                                            let newValue = _val.match(/<a [^>]+>([^<]+)<\/a>/);
                                            if (newValue) {
                                                copied[key] = newValue[1];
                                            } else {
                                                copied[key] = "";
                                            }
                                        }

                                        if (_.contains(dates, key)) {
                                            copied[key] = new Date(moment.tz(_val, $rootScope.timezone).toISOString());

                                        }

                                        if (_.contains(dt, key)) {
                                            copied[key] = new Date(moment.tz(_val, _format, $rootScope.timezone).startOf('day').toISOString());

                                        }

                                        if (references.includes(key)) {
                                            console.log('dataStore', dataStore);
                                            copied[key] = {
                                                label: _val,
                                                value: (dataStore[rowId] && dataStore[rowId][key]) ? dataStore[rowId][key].value : "global"
                                            };
                                        }

                                        if (typeof _val === 'undefined') {
                                            copied[key] = "";
                                        }
                                    });

                                    // console.log("ALL D " + JSON.stringify(copied));
                                    // return;
                                    _ids = [];

                                    if (!_.isUndefined(copied["sequence"]))
                                        $http.get("/o/sequence.bto/" + scope.table).then(function (response) {
                                            $log.debug(response);
                                            copied["sequence"] = response.value;
                                            executeThis();
                                        });
                                    else {
                                        executeThis();
                                    }
                                }

                                function executeThis() {
                                    function cb(response) {
                                        if (response.status === 200) {
                                            table.trigger('reloadGrid', [{
                                                page: lastPage //table.getGridParam('page')//
                                            }]);
                                            swal("Success", "DONE", "success");
                                        } else {
                                            swal("Problem", response.data, "warning");
                                        }

                                        copied = {};

                                    }

                                    swal({
                                        title: "Are you sure?",
                                        text: "Would you like to copy and insert this record?",
                                        type: "info",
                                        showCancelButton: true,
                                        cancelButtonClass: "btn-default",
                                        confirmButtonText: "Copy",
                                        confirmButtonClass: "btn-primary"
                                    }).then((result) => {
                                        if (result.value) {
                                            $http.post("/o/" + scope.table + "/", copied).then(cb);
                                        } else {
                                            swal("Cancelled", "Copy & Insert Action Cancelled.", "error");
                                        }
                                    });
                                }

                                jQuery("#chngroup").change(function () {
                                    let vl = $(this).val();
                                    //alert(vl);
                                    if (vl) {
                                        if (vl === "clear") {
                                            table.jqGrid('groupingRemove', true);
                                        } else {
                                            table.jqGrid('groupingGroupBy', vl);
                                        }
                                    }
                                });

                                if (inlineNav) {
                                    table.jqGrid('inlineNav', '#' + pagerId, scope.inlineConfig);
                                }

                                // element.find('.ui-jqgrid-bdiv').css('height', gridHeight);
                                // element.find(".glyphicon-refresh").attr('data-feather', 'refresh-cw');
                                // element.find(".glyphicon-plus").attr('data-feather', 'plus');
                                //
                                // element.find(".glyphicon-step-backward").attr('data-feather', 'skip-back');
                                // element.find(".glyphicon-backward").attr('data-feather', 'rewind');
                                // element.find(".glyphicon-forward").attr('data-feather', 'fast-forward');
                                // element.find(".glyphicon-step-forward").attr('data-feather', 'skip-forward');
                                // element.find(".glyphicon-menu-hamburger").attr('data-feather', 'menu');
                                //
                                // element.find(".glyphicon-save").attr('data-feather', 'save');
                                // element.find(".glyphicon-remove-circle").attr('data-feather', 'x-circle');
                                // element.find(".glyphicon-trash").attr('data-feather', 'trash-2');
                                // element.find(".fa-copy").attr('data-feather', 'copy');
                                // element.find(".fa-file-excel").attr('data-feather', 'download');
                                // element.find(".fa-list").attr('data-feather', 'list');
                                // element.find(".fa-attach").attr('data-feather', 'paperclip');

                                "use strict";
                                caculateWidth("1", shouldIShrink);
                                $compile(element.contents())(scope);
                                caculateWidth("1.5", shouldIShrink);
                                table.jqGrid('destroyFrozenColumns');
                                table.jqGrid('destroyFrozenColumns').jqGrid('setColProp', 'updated_on', { frozen: true }).jqGrid('setFrozenColumns').trigger('reloadGrid', [{ current: true }]); // optional
                                table.jqGrid('setFrozenColumns');

                                // Restore filter toolbar inputs from URL params after grid is fully initialized.
                                // This must run after: filterToolbar creation, frozen columns, and reloadGrid completion.
                                // Using a one-time loadComplete listener ensures the DOM is fully settled.
                                if (!embedded && Object.keys($routeParams).length > 0) {
                                    table.one('jqGridAfterLoadComplete', () => {
                                        restoreToolbarInputs($routeParams);
                                    });
                                }
                            });
                        }
                    }, true);

                    function style_edit_form(form) {
                        //enable datepicker on "sdate" field and switches for "stock" field
                        form.find('input[name=sdate]').datepicker({
                            format: 'yyyy-mm-dd',
                            autoclose: true
                        });

                        form.find('input[name=stock]').addClass('ace ace-switch ace-switch-5').after('<span class="lbl"/>');

                        let buttons = form.next().find('.EditButton .fm-button');
                        buttons.addClass('btn btn-sm').find('[class*="-icon"]').hide(); //ui-icon, s-icon
                        buttons.eq(0).addClass('btn-primary').prepend('<i class="ace-icon fa fa-check"/>');
                        buttons.eq(1).prepend('<i class="ace-icon fa fa-times"/>');

                        buttons = form.next().find('.navButton a');
                        buttons.find('.ui-icon').hide();
                        buttons.eq(0).append('<i class="ace-icon fa fa-chevron-left"/>');
                        buttons.eq(1).append('<i class="ace-icon fa fa-chevron-right"/>');
                    }
                }
            };
        }
    ]);
